import { clsx } from 'clsx'
import type { ReactNode } from 'react'

type Variant = 'default' | 'required' | 'preferred' | 'success' | 'warning' | 'error' | 'muted'

const styles: Record<Variant, string> = {
  default: 'bg-surface-lowest text-text-muted border border-border-subtle',
  required: 'bg-accent-error-light text-accent-error',
  preferred: 'bg-primary-light text-primary',
  success: 'bg-accent-success-light text-accent-success',
  warning: 'bg-accent-warning-light text-accent-warning',
  error: 'bg-accent-error-light text-accent-error',
  muted: 'bg-surface-lowest text-text-faint border border-border-subtle',
}

export default function Badge({
  children,
  variant = 'default',
  className,
}: {
  children: ReactNode
  variant?: Variant
  className?: string
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap',
        styles[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
